import React, { useEffect } from 'react'
import styles from '../../Css/CustomSettings.module.css'
import '../../Css/Common.css'
import Toggle from 'react-toggle'
import Dropzone from 'react-dropzone'
import '../../Css/Scanner.css'
import { LightgalleryProvider, LightgalleryItem } from "react-lightgallery"
import "lightgallery.js/dist/css/lightgallery.css"
import ImageSectionModal from '../Modals/ImageSectionModal';

function ImageSectionBulk(props) {

    const fileHandler = (acceptedFiles) => {
        props.multipleFileUpload(acceptedFiles)
    }

    useEffect((e) => {

    }, [props.isDisSatisfied, props.toggleStatus])

    console.log(`fileListArray`,JSON.parse(window.sessionStorage.getItem(`${props.random}fileList`)));
    return (
        <div>
            {props.imageSectionModalImage ? <ImageSectionModal imageSectionModalImage = {props.imageSectionModalImage}/> : null}
            <div className={[styles['image-area']].join(' ')}>
                <div className={[styles['image-area-bulk']].join(' ')}>
                    <div className={[styles['grid-area']].join(' ')}>
                        {!props.uploadStarted ?
                            <Dropzone onDrop={acceptedFiles => fileHandler(acceptedFiles)} >
                                {({ getRootProps, getInputProps }) => (
                                    <div {...getRootProps({})} className={[styles['add-images-card']].join(' ')}>
                                        <img src="https://storage.googleapis.com/spyne-website/static/website-themes/clippr/static/Vector.svg" />
                                        <h4>Add Image</h4>
                                        <input onChange={fileHandler} ref={(fileInput) => (this.fileInput = fileInput)} type="file" {...getInputProps()} />
                                    </div>
                                )}
                            </Dropzone>
                            :
                            null
                        }
                        
                        
                        <div className={[styles['grid-image-bulk']].join(' ')}>
                                <LightgalleryProvider
                                        lightgallerySettings={{
                                            "download": true,
                                            "thumbnail": false,
                                            "fullScreen": true,
                                            "zoom": true
                                        }}
                                    >
                        {props.fileList.map((e, i) => {
                             if(e.status === "Uploading" || !props.toggleStatus ){
                                return <div style={{position:"relative"}}>
                                
                                            <LightgalleryItem itemClassName='px-0' style={{ padding: "0px" }} src={e.url}>
                                                <img src={e.url} />
                                            </LightgalleryItem>
                                            {!props.uploadStarted ?
                                        <div className={[styles['image-detail-delete']].join(' ')}>
                                            <p>{e.name}</p>
                                            <img onClick={() => props.updateMultipleImageList(i)} src="https://storage.googleapis.com/spyne-website/static/website-themes/clippr/static/Group%205893821.svg" />
                                        </div>
                                        :
                                        e.status === "Uploading" ?
                                            <div className={[styles['scan'], 'scan'].join(' ')} />
                                            :
                                            props.isDisSatisfied ?
                                                <div className={[styles['unsatisfied']].join(' ')}>
                                                    <p>{e.name}</p>
                                                    <img onClick={() => props.getRefundModal(i)} src="https://storage.googleapis.com/spyne-website/static/website-themes/clippr/static/Group%205893821.svg" />
                                                </div>
                                                :
                                                null
                                    }
                                </div>
                             }
                             return null;
                                
                        })}
                                </LightgalleryProvider>
                                     <LightgalleryProvider
                                        lightgallerySettings={{
                                            "download": true,
                                            "thumbnail": false,
                                            "fullScreen": true,
                                            "zoom": true
                                        }}
                                    >
                        {props.fileList.map((e, i) => {
                            if(e.status!= "Uploading" && props.toggleStatus ){
                            return < div style={{position:"relative"}}>
                            
                                           { e.status === "Error" ?
                                                <img src="https://storage.googleapis.com/spyne-website/static/website-themes/clippr/static/Error-512.png" />
                                                : <div>
                                            
                                                    <LightgalleryItem itemClassName='px-0' style={{ padding: "0px" }} src={e.thumbnailOutput}>
                                                        <img src={e.thumbnailOutput} />
                                                    </LightgalleryItem>
                                                    {!props.uploadStarted ?
                                        <div className={[styles['image-detail-delete']].join(' ')}>
                                            <p>{e.name}</p>
                                            <img onClick={() => props.updateMultipleImageList(i)} src="https://storage.googleapis.com/spyne-website/static/website-themes/clippr/static/Group%205893821.svg" />
                                        </div>
                                        :
                                        e.status === "Uploading" ?
                                            <div className={[styles['scan'], 'scan'].join(' ')} />
                                            :
                                            props.isDisSatisfied ?
                                                <div className={[styles['unsatisfied']].join(' ')}>
                                                    <p>{e.name}</p>
                                                    <img onClick={() => props.getRefundModal(i)} src="https://storage.googleapis.com/spyne-website/static/website-themes/clippr/static/Group%205893821.svg" />
                                                </div>
                                                :
                                                null
                                    }
                                     </div>
                                           }
                                        </div>

                         } 
                         return null;
                         })} </LightgalleryProvider>
                                   
                    </div>
                
                    </div>
                </div>
                {props.isEditingStart ?
                <div className={[styles['toggle-section-bulk'], "sec-2-toggle"].join(' ')}>
                    <p className="mr-5 mt-2">Original</p>
                    <label className="mt-2">
                        {props.fileList && props.fileList[0] && props.fileList[0].thumbnailOutput?
                        <Toggle onClick={props.handleToggleImage} icons={false} checked={props.toggleStatus} />:
                        <Toggle onClick={props.handleToggleImage} icons={false} checked={false} />}
                    </label>
                    <p className="ml-5 mt-2">Edited</p>
                </div>:null}
            </div>
        </div>
    )
}
export default ImageSectionBulk